import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createEntityDocument, deleteEntityDocument, getEntityDocuments, updateEntityDocument } from "../../api/entities/Document";
import { DocumentForm } from "../../types/forms/entity";

export const useEntityDocument = (entityIdStr?: string) => {
  const queryClient = useQueryClient();
  const entityId = Number(entityIdStr);

  const queryKey = ["entity", entityId, "Document"];

  const result = useQuery({
    queryKey,
    queryFn: () => getEntityDocuments(entityId),
    enabled: !!entityId,
  });

  const createMutation = useMutation({
    mutationFn: (values: DocumentForm) => createEntityDocument(entityId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  const updateMutation = useMutation({
    mutationFn: ({ DocumentId, values }: { DocumentId: number, values: DocumentForm }) => updateEntityDocument(entityId, DocumentId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  const deleteMutation = useMutation({
    mutationFn: (DocumentId: number) => deleteEntityDocument(entityId, DocumentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    }
  });

  return {
    documentsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    createDocument: createMutation.mutateAsync,
    updateDocument: updateMutation.mutateAsync,
    deleteDocument: deleteMutation.mutateAsync,
    isUpdating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
  }
}